import { CRRender } from "@/components/crRender";
import { Icon } from "@iconify/react/dist/iconify.js";

const Badge = ({ title, className="", icon }) => {
  return <span className={` ${className}`}>
    <CRRender condition={icon}>
      <Icon icon={icon} className="me-1" />
    </CRRender>
    {title}</span>;
};

export default Badge;
